import React from 'react'
import logo1 from '../Components/images/logo1.png'
import logo2 from '../Components/images/logo2.png'
import logo3 from '../Components/images/logo3.png'
import logo4 from '../Components/images/logo4.png'
import logo5 from '../Components/images/logo5.png'
import cow from '../Components/images/cow.jpg'
import img2 from '../Components/images/img2.jpg'
import img3 from '../Components/images/img3.jpg'
import img4 from '../Components/images/img4.jpg'
import img5 from '../Components/images/img5.jpg'

const Communities = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="bg11 border-t-2 border-t-gray-100 my-3">
                    <div className="md:w-[56%]  w-full md:left-[27%]   top-0 bottom-0 relative">
                        <div className="md:mx-0 mx-4">
                            <div className="py-14">
                                <h1 className='text-[2.5rem] font-black text-[#004A8B]'>Our communities</h1>
                                <h1 className='border-b-[.4rem] border-[#B5D1B3] w-[3.5rem]'></h1>
                            </div>
                            <div className="">
                                <p className='md:text-[1.5rem] text-[1.2rem] font-black text-[#004A8B] tracking-wider leading-8'>
                                    When LAWD was formed in 2020, the founders were determined to ensure one of company's  most central values would always be a commitment to community.
                                </p>

                                <p className='py-5 leading-7 tracking-wider'>
                                    Since that time, the team has given its support to numerous sponsorships, partnerships and speaking engagements across the country from national events, charities and scholarship programs to smaller organisations making an important difference in their local area.
                                    One of our priorities is supporting and championing those who work to nurture the careers, health and wellbeing of young Australians, including those in rural and regional communities.
                                </p>
                                <p className='py-5 leading-7 tracking-wider'> As a company that is driven to be innovative, we also support those who promote leadership and innovation, and participate in events including the Global Food Forum, evokeAG. and Beef Australia.</p>
                            </div>
                            <div className="">
                                <h1 className='text-[15px] font-black'>Our partners include</h1>
                            </div>
                        </div>

                    </div>


                    <div className="flex md:flex-row flex-col  items-center justify-center mx-10 my-10">
                        <div className="md:mx-10 md:my-1 my-4">
                            <a href="/Community"><img src={logo1} alt="logo" /></a>
                        </div>
                        <div className="md:mx-10 md:my-0 my-6">
                            <a href="/Community"><img src={logo2} alt="logo" /></a>
                        </div>
                        <div className="md:mx-10  md:my-1 my-5">
                            <a href="/Community"><img src={logo3} alt="logo" /></a>
                        </div>
                        <div className="md:mx-10  md:my-1 my-5">
                            <a href="/Community"><img src={logo4} alt="logo" /></a>
                        </div>
                        <div className="md:mx-10  md:my-4 my-6">
                            <a href="/Community"><img src={logo5} alt="logo" /></a>
                        </div>
                    </div>
                    <div className='' />

                </div>

                <div className="md:py-20">

                    <div className="grid grid-cols-12 mx-5  lg:mx-32 gap-6">

                        <div className="md:col-span-4 bg-red-200 col-span-12 relative  group">
                            <a href="" className=''><img src={cow} alt="" className='w-full' />
                                <span className='group-hover:pb-7  grade transition-all  ease-in-out duration-400 bottom-0 absolute text-white left-0 right-0 p-[16px]'>
                                    <span className='block font-black'>Zanada McDonald</span>
                                    <span>zandamcdonaldaward.com</span>
                                </span>

                            </a>
                        </div>

                        <div className="md:col-span-4  col-span-12  relative group">
                            <a href="" className=''><img src={img2} alt="" className='w-full' />
                                <span className='group-hover:pb-7 grade transition-all  ease-in-out duration-400 bottom-0 absolute text-white left-0 right-0 p-[16px]'>
                                    <span className='block font-black'>Zanada McDonald</span>
                                    <span>zandamcdonaldaward.com</span>
                                </span>

                            </a>
                        </div>

                        <div className="md:col-span-4  col-span-12  relative group">
                            <a href="" className=''><img src={img3} alt="" className='w-full' />
                                <span className='group-hover:pb-7 grade transition-all  ease-in-out duration-400 bottom-0 absolute text-white left-0 right-0 p-[16px]'>
                                    <span className='block font-black'>Zanada McDonald</span>
                                    <span>zandamcdonaldaward.com</span>
                                </span>

                            </a>
                        </div>

                    </div>

                    <div className="grid grid-cols-12 gap-6  my-5 mx-5 lg:mx-[20rem] ">

                        <div className="md:col-span-6  col-span-12  relative group">
                            <a href="" className=''><img src={img4} alt="" className='w-full' />
                                <span className='group-hover:pb-7 grade transition-all  ease-in-out duration-400 bottom-0 absolute text-white left-0 right-0 p-[16px]'>
                                    <span className='block font-black'>Zanada McDonald</span>
                                    <span>zandamcdonaldaward.com</span>
                                </span>

                            </a>
                        </div>

                        <div className="md:col-span-6  col-span-12  relative group">
                            <a href="" className=''><img src={img5} alt="" className='w-full' />
                                <span className='group-hover:pb-7 grade transition-all  ease-in-out duration-400 bottom-0 absolute text-white left-0 right-0 p-[16px]'>
                                    <span className='block font-black'>Zanada McDonald</span>
                                    <span>zandamcdonaldaward.com</span>
                                </span>

                            </a>
                        </div>

                    </div>
                </div>
            </div>


        </>
    )
}

export default Communities